import moment, { Moment } from 'moment';

const toMoment = (date: Date): Moment => moment(date);

export default toMoment;
